<div class="header">
    <app-header (themeChange)="mudarTema($event)"></app-header>
</div>
<div class="container">
    <app-ga-consent-dialog></app-ga-consent-dialog>
    <router-outlet></router-outlet>
</div>
